import React, { useState, useCallback } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import AnexoIcone from "./AnexoIcone";
import './styles.css';
import { useDropzone } from 'react-dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';

export default function Anexos({ listaAnexos, setListaAnexos, filesTypes, descricao="Arraste ou clique para carregar um arquivo. Máximo 5Mb"}) {
    const extensaoImagem = ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'ico', 'jfif'];
    const [lista, setLista] = useState(listaAnexos ?? []);

    const removeAnexo = useCallback(
        (idArquivo) => {
            const novaLista = [...listaAnexos];
            novaLista.splice(idArquivo, 1);
            setListaAnexos(novaLista);
            const novaListaFiles = [...lista];
            novaListaFiles.splice(idArquivo, 1);
            setLista(novaListaFiles);
        },
        [listaAnexos, setListaAnexos, lista]
    );

    const handleVerifyType = (file) => {
        const extensao = (file?.name ?? file?.nome)?.split('.').pop();
        if (extensaoImagem.includes(extensao)) {
            return true;
        } else {
            return extensao
        }
    };

    async function onDrop(acceptedFile) {        
        if(acceptedFile){
            let arquivoUltrapassou = false;

            acceptedFile.forEach(file => {
                if( Math.round((file.size / 1024)) > 20000){
                    arquivoUltrapassou = true;
                    return;
                }
            });            

            if(arquivoUltrapassou){
                Swal.fire({
                    titleText: "Ooops...",
                    text: "Arquivo com tamanho não suportado. O máximo é de 20Mb",
                    icon: "warning",
                });
            }else{
                let listTemp = [...lista, ...acceptedFile];
                setLista(listTemp);
                setListaAnexos(listTemp);
            }
        }        
    }

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    return <>
        <div {...getRootProps()} className="upload-area">
            <input {...getInputProps()} accept={filesTypes}/>
            <p>{descricao}</p>
        </div>
        <div className='previews-itens'>
            {
                lista && lista.map((file, index) => (          
                    <div className='item-card' key={index}>
                        <div className='preview-item' onClick={() => window.open(file?.link ?? URL.createObjectURL(file), '_blank')}>
                            {handleVerifyType(file) === true
                                ? (<>
                                    < img className="img_upload" src={URL.createObjectURL(file)} alt={file.name} />
                                </>
                                )
                                :
                                <AnexoIcone anexo={handleVerifyType(file)} style={{ fontSize: "10rem" }} />
                            }
                        </div>                        
                        <div className='header-item-card'>
                            <OverlayTrigger
                                key={index}
                                placement="top"
                                overlay={
                                    <Tooltip id={String(index)}>
                                        {file ? (file?.name ?? file?.nome): " "}
                                    </Tooltip>
                                }
                            >
                                <span className='item-name' data-tip={file?.name ?? ""}>
                                    {file ? (file?.name ?? file?.nome) : " "}
                                </span>                                
                            </OverlayTrigger>
                            <span className='btn-remove-item' onClick={() => removeAnexo(index)}>
                                <FontAwesomeIcon icon={faTrash}/>
                            </span>
                        </div>
                    </div>
                ))
            }
        </div>
    </>
}
